<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
  },
  mounted() {
    
    if(location.href.includes("1027") || location.href.includes("how")){
      location.href="/how_intro";
    }else{
      location.href="/login";
    }
  },

}
</script>
